import { Component, Inject, Vue, Mixins } from "vue-property-decorator";
import CookiesBanner from "@/shared/components/cookies-banner.vue";

import TranslationService from "./shared/services/translation.service";
import GlobalMixin from "./shared/mixins/global-mixin";
import Ribbon from "@/core/ribbon/ribbon.vue";
import GlobalService from "./shared/services/global.service";

@Component({
  components: {
    CookiesBanner,
    Ribbon,
  },
})
export default class App extends Mixins(GlobalMixin) {
  @Inject("translationService") public translationService: () => TranslationService;
  @Inject("globalService") public globalService: () => GlobalService;
  private appReady: boolean = false;
  private get screenHeight() {
    return window.innerHeight;
  }

  private get screenWidth() {
    return window.innerWidth;
  }

  public created() {
    this.initApp();
  }

  public async initApp() {
    // wait for data to avoid sync problems
    await this.setYmlConstants(); // init store with yml constants

    let choice = this.$cookies.get("cookie_choice_opt");
    // replace cookie if value is previously managed value (i.e. 'accepted' instead of consent)
    // code can be removed in December, 2023
    if (choice == 'accepted') {
      choice = {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        security_storage: 'granted',
      };
      this.$cookies.set("cookie_choice_opt", choice, 60 * 60 * 24 * 30 * 2);
    }
    if (choice !== null) this.startGtagTracking(choice);
    await this.translationService().refreshCurrency(sessionStorage.getItem("currency"));
    await this.retrieveProfiles();
    this.appReady = true;
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  /*
   * need to know active profiles for cheat bar on the side, retrieve profiles from backend
   */
  private async retrieveProfiles() {
    let res = await this.globalService().getActiveProfiles();
    if (res.activeProfiles) {
      this.$store.commit("setRibbonOnProfiles", res["display-ribbon-on-profiles"]);
      this.$store.commit("setActiveProfiles", res["activeProfiles"]);
    }
  }
}
